import React from "react"

import { ColDef, ICellRendererParams } from "@ag-grid-community/core"
import { FileLink } from "modules/common/components/files/FileLink"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { getColumnSize } from "modules/common/services/table/size-storage"
import { eat } from "modules/common/services/typescript"
import { PendingSignatureItemType, fields } from "modules/main/models/order-content-task-signatures"
import { calculateTextHeight } from 'modules/order-questions/components/columns'
import styles from "./SignaturesList.module.scss"

export const columns = (tableName: string, baseUrl: string, onSignClick: (signature: PendingSignatureItemType) => void) => {
  const columnSize = getColumnSize(tableName)

  const result: ColDef[] = [
    {
      headerName: "№",
      field: "index",
      width: 50,
      sortable: true,
      resizable: false, wrapText: true,
      autoHeight: true,
      cellStyle: { wordBreak: "normal", lineHeight: "unset" },
      valueGetter: (params: any) => {
        return (params.node?.rowIndex ?? 0) + 1
      },
    },
    {
      headerName: "Инв №",
      field: fields.orderNumber,
      width: columnSize(fields.orderNumber, 100),
      sortable: true,
      resizable: false,
      cellRendererFramework: ({ data }: ICellRendererParams) => {
        return (
          <div className={styles.cellWithTooltip}>
            <span className={styles.orderNumber}>{data.orderNumber}</span>
          </div>
        )
      },
    },
    {
      headerName: "Проект",
      field: fields.orderName,
      width: columnSize(fields.orderName, 280),
      sortable: true,
      resizable: false, wrapText: true,
      autoHeight: true,
      cellStyle: { wordBreak: "normal", lineHeight: "unset" },
      cellRendererFramework: ({ data }: ICellRendererParams) => {

        return <span>{data.orderName}</span>
      },
    },
    // {
    //   headerName: "Раздел",
    //   field: fields.contentName,
    //   width: columnSize(fields.contentName, 290),
    //   sortable: true,
    //   resizable: false,   wrapText: true,
    // autoHeight: true,
    // cellStyle: { wordBreak: "normal", lineHeight: "unset" },
    //   cellRendererFramework: ({ data }: ICellRendererParams) => {
    //     if (data.contentName && data.contentName.length > 25) {
    //       return (
    //         <Popover
    //           position="left"
    //           usePortal={true}
    //           interactionKind="hover"
    //           content={<div className={styles.tooltipContent}>{data.contentName}</div>}
    //         >
    //           <div className={`${styles.cutRow} ${Classes.TOOLTIP_INDICATOR}`} style={{ maxWidth: "230px" }}>
    //             {data.contentName}
    //           </div>
    //         </Popover>
    //       )
    //     }
    //     return <span>{data.contentName}</span>
    //   },
    // },
    {
      headerName: "Роль",
      field: fields.signerTypeDisplay,
      width: columnSize(fields.signerTypeDisplay, 140),
      sortable: true,
      resizable: false, wrapText: true,
      autoHeight: true,
      cellStyle: { wordBreak: "normal", lineHeight: "unset" },
      cellRendererFramework: ({ data }: ICellRendererParams) => {
        return (
          <span className={`${styles.roleBadge} ${styles[data.signerType]}`}>
            {data.signerTypeDisplay}
          </span>
        )
      },
    },
    {
      headerName: "Файл",
      field: fields.fileName,
      width: columnSize(fields.fileName, 320),
      sortable: true,
      resizable: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: ({ data }: ICellRendererParams) => {
        let height = 0
        const lineHeight = 14 // Высота строки
        if (data.fileName.length > 0) {
          const textHeight = calculateTextHeight(data.fileName, 270, lineHeight)
          height += 40
          height += textHeight

        }
        return { "min-height": `${height}px` }
      },
      cellRendererFramework: ({ data }: ICellRendererParams) => {
        if (!data.fileName) return <span className={styles.noDataCell}>Нет файла</span>

        return (
          <div>
            <FileLink
              baseUrl={baseUrl}
              file={{
                fileId: data.fileId,
                fileName: data.fileName,
              }}
              readOnly={true}
              onRemove={eat}
              style={{
                whiteSpace: "normal",
                fontSize: " 11px",
                height: "auto",
                padding: "8px 12px",
                borderColor: "#ea561e",
                color: "#ea561e",
                width: "300px"
              }}
            />
          </div>


        )
      },
    },
    {
      headerName: "Версия",
      field: fields.version,
      width: columnSize(fields.version, 120),
      sortable: true,
      resizable: false, wrapText: true,
      autoHeight: true,
      cellStyle: { wordBreak: "normal", lineHeight: "unset" },
      cellRendererFramework: ({ data }: ICellRendererParams) => {
        return <span className={styles.version}>v{data.version}</span>
      },
    },
    {
      headerName: "Дата",
      field: fields.createdAt,
      width: columnSize(fields.createdAt, 110),
      sortable: true,
      resizable: false, wrapText: true,
      autoHeight: true,
      cellStyle: { wordBreak: "normal", lineHeight: "unset" },
      cellRendererFramework: ({ data }: ICellRendererParams) => {

        return (
          <span>
            {data.date}
          </span>
        )
      },
    },
    {
      headerName: "",
      field: "actions",
      width: 100,
      sortable: false,
      resizable: false, wrapText: true,
      autoHeight: true,
      cellStyle: { wordBreak: "normal", lineHeight: "unset" },
      cellRendererFramework: (params: ICellRendererParams) => {
        // const getContext = () => params.context as TableContext

        return (
          <div className={styles.actions}>
            <PlanrButton
              type="greenish"
              size='small'
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation()
                onSignClick(params.data)
              }}
              style={{ height: "25px", width: "80px", fontSize: "11px", padding: "0px 5px" }}
            >
              Подписать
            </PlanrButton>
          </div>
        )
      },
    },
  ]

  return result
}

export interface TableContext {
}
